import {
  AchPaymentMethodPaymentMethodTypeEnum,
  BillingInfo as BillingInfoDto,
  CardPaymentMethodPaymentMethodTypeEnum,
  CollectionMethod,
  CurrencyType,
  CustomerHasPendingSubscriptionChange as CustomerHasPendingSubscriptionChangeDto,
  GetPaymentTermsResult as PaymentTermsResultDto,
  LicenseCountAmendment as LicenseCountAmendmentDto,
  PaymentMethodCategory,
  PaymentMethodsList as PaymentMethodsListDto,
  ResponseListPaymentMethodsV1 as PaymentMethodsListV1Dto,
  TransactionEstimate as TaxesEstimationResponseDto,
} from '@electricjs/core_entity-client';

import { InvoiceResponse } from '@/types/billing';

export const invoicesList: InvoiceResponse[] = [
  {
    id: 'a8c230000000RzdAAE',
    name: 'INV-2618',
    total_amount: 4580.88,
    invoice_date: '2023-10-23',
    content_documents: undefined,
    has_documents: false,
  },
  {
    id: 'a8c230000000S0nAAE',
    name: 'INV-2639',
    total_amount: 0,
    invoice_date: '2023-10-24',
    content_documents: undefined,
    has_documents: false,
  },
  {
    id: 'a8c230000000S3QAAU',
    name: 'INV-2698',
    total_amount: 0,
    invoice_date: '2024-07-01',
    content_documents: undefined,
    has_documents: false,
  },
  {
    id: 'a8c230000000S3hAAE',
    name: 'INV-2715',
    total_amount: 1717,
    invoice_date: '2024-07-01',
    content_documents: undefined,
    has_documents: true,
  },
  {
    id: 'a8c230000000S6YAAU',
    name: 'INV-2771',
    total_amount: 227.25,
    invoice_date: '2024-01-01',
    content_documents: undefined,
    has_documents: false,
  },
  {
    id: 'a8c230000000S7vAAE',
    name: 'INV-2773',
    total_amount: 0,
    invoice_date: '2023-11-01',
    content_documents: undefined,
    has_documents: false,
  },
];

const billingAddress = {
  line1: '915 Broadway',
  line2: 'Suite 802',
  city: 'New York',
  region: 'NY',
  country_code: 'US',
  postal_code: '10010',
};

export const billingInfo: BillingInfoDto = {
  organization_id: 'simple-org-id',
  billing_address: billingAddress,
  billing_email: 'billing@example.com',
};

export const paymentMethodsV1: PaymentMethodsListV1Dto = {
  card_payment_methods: [
    {
      payment_method_id: 'pm-card-1',
      address: billingAddress,
      owner_user_id: 'simple-user-id',
      is_user_default: true,
      nickname: 'Company card',
      payment_method_type: CardPaymentMethodPaymentMethodTypeEnum.Card,
      brand: 'visa',
      display_brand: 'Visa',
      expiration_month: 12,
      expiration_year: 2030,
      last_four_digits: '4242',
    },
  ],
};

export const paymentMethodsV3: PaymentMethodsListDto = {
  payment_methods: [
    {
      payment_method_id: 'pm-card-1',
      address: billingAddress,
      owner_id: 'simple-org-id',
      category: PaymentMethodCategory.Organization,
      is_default: true,
      nickname: 'Company card',
      payment_method_type: CardPaymentMethodPaymentMethodTypeEnum.Card,
      brand: 'visa',
      display_brand: 'Visa',
      expiration_month: 12,
      expiration_year: 2030,
      last_four_digits: '4242',
    },
    {
      payment_method_id: 'pm-ach-1',
      address: billingAddress,
      owner_id: 'simple-org-id',
      category: PaymentMethodCategory.Organization,
      is_default: false,
      nickname: 'Company bank account',
      payment_method_type: AchPaymentMethodPaymentMethodTypeEnum.Ach,
      bank_name: 'Test Bank',
      account_holder_type: 'company',
      account_type: 'checking',
      last_four_digits: '6789',
    },
  ],
};

export const paymentTerms: PaymentTermsResultDto = {
  payment_terms: { collection_method: CollectionMethod.ChargeAutomatically },
};

export const taxesEstimation: TaxesEstimationResponseDto = {
  initial_payment: {
    line_item_taxes: [
      {
        line_item: {
          name: 'Dell Laptop Latitude',
          unit_price: '1000.00',
          quantity: 1,
          sku: '11111',
        },
        tax_rates: [],
      },
    ],
    total_tax_estimate: '82.50',
  },
  total_tax_estimate: '82.50',
  transaction_currency: CurrencyType.Usd,
};

export const licenseCountAmendment: LicenseCountAmendmentDto = {
  organization_id: 'simple-org-id',
  product_id: 'e97bdcd7-c243-4d12-8ae1-23729d49c3e6',
  previous_license_count: 100,
  new_license_count: 120,
};

export const noPendingSubscriptionChange: CustomerHasPendingSubscriptionChangeDto =
  {
    organization_id: 'simple-org-id',
    has_pending_subscription_change: false,
  };
